import React, { useState } from "react";
import Autosuggest from "react-autosuggest";
import { getAirlineDetails } from "app/services/charterService";

const Carrier = ({ index, setFieldValue }) => {
  const [value, setValue] = useState("");
  const [suggestions, setSuggestions] = useState([]);

  // Fetch suggestions
  const getSuggestions = async (value) => {
    const inputValue = value.trim().toLowerCase();

    if (!inputValue) return [];

    try {
      const data = await getAirlineDetails(inputValue);

      if (!data || data.Error) return [];

      return data.map((detail) => ({
        id: detail.id,
        label: `${detail.carrierCode} ${detail.carrierName}`,
      }));
    } catch (err) {
      console.error(err);
      return [];
    }
  };

  // When suggestion selected
  const onSuggestionSelected = (fieldName, suggestion) => {
    setValue(suggestion.label);
    setFieldValue(fieldName, suggestion.id);
  };

  // What goes into input when selected
  const getSuggestionValue = (suggestion) => suggestion.label;

  // Render dropdown item
  const renderSuggestion = (suggestion) => <div>{suggestion.label}</div>;

  // Input change
  const onChange = (event, { newValue }) => {
    setValue(newValue);

    setFieldValue(`flightLegs.onward[${index}].airline`, "");
  };

  // Fetch on typing
  const onSuggestionsFetchRequested = async ({ value }) => {
    const data = await getSuggestions(value);
    setSuggestions(data);
  };

  // Clear suggestions
  const onSuggestionsClearRequested = () => {
    setSuggestions([]);
  };

  const inputProps = {
    placeholder: "Carrier",
    value,
    onChange,
    className: "form-control",
    id: `flightLegs.onward[${index}].airline`,
    name: `flightLegs.onward[${index}].airline`,
  };

  return (
    <Autosuggest
      suggestions={suggestions}
      onSuggestionsFetchRequested={onSuggestionsFetchRequested}
      onSuggestionsClearRequested={onSuggestionsClearRequested}
      getSuggestionValue={getSuggestionValue}
      renderSuggestion={renderSuggestion}
      inputProps={inputProps}
      onSuggestionSelected={(event, { suggestion }) =>
        onSuggestionSelected(`flightLegs.onward[${index}].airline`, suggestion)
      }
    />
  );
};

export default Carrier;
